import styled from 'styled-components';
import { Card } from '@shared/ui/Card';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  & > * {
    min-width: 0;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const RatesSubtext = styled.div`
  font-size: 12px;
  opacity: 0.75;
  margin-top: 2px;
`;

export const KpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
`;

export const KpiCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const KpiCardLabel = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const KpiCardValue = styled.div`
  font-size: 20px;
  font-weight: 800;
`;

export const KpiSuccessText = styled.div`
  font-size: 12px;
  color: #10b981;
`;

export const KpiSubtext = styled.div`
  font-size: 12px;
  opacity: 0.75;
`;

export const KpiWarningValue = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: #f59e0b;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 12px;
`;

export const MonthBox = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MonthBoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MonthBoxTitle = styled.strong`
  font-size: 15px;
`;

export const MonthTotal = styled.div`
  font-size: 20px;
  font-weight: 800;
`;

export const MonthDetailRow = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: space-between;
`;

export const MonthFooterRow = styled.div`
  font-size: 11px;
  padding-top: 6px;
  border-top: 1px dashed rgba(148, 163, 184, 0.25);
  display: flex;
  justify-content: space-between;
`;

export const MonthPaidText = styled.span`
  color: #10b981;
`;

export const TableWrap = styled.div`
  overflow-x: auto;
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  th,
  td {
    padding: 11px 13px;
    text-align: left;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }
  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${({ theme }) => theme.colors.text.muted};
    background: ${({ theme }) => theme.colors.backgroundElevated};
  }
  tr:last-child td {
    border-bottom: none;
  }
`;

export const FormBox = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 10px;
`;

export const Input = styled.input`
  padding: 7px 11px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.backgroundElevated};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
`;

export const Select = styled.select`
  min-width: 0;
  max-width: 100%;
  padding: 7px 11px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.backgroundElevated};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
`;

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  cursor: pointer;
`;

export const FormErrorMessage = styled.div`
  font-size: 12px;
  color: #ef4444;
  fontWeight: 600;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ContractNumberText = styled.div`
  font-weight: 700;
  margin-top: 4px;
`;

export const MutedDateText = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const CreditorNameText = styled.div`
  font-weight: 700;
`;

export const MutedBankText = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const TitleCell = styled.td`
  max-width: 340px;
`;

export const TitleText = styled.div`
  font-weight: 600;
`;

export const LeasedAssetText = styled.div`
  font-size: 12px;
  color: #38bdf8;
  margin-top: 2px;
`;

export const LimitText = styled.div`
  font-weight: 800;
`;

export const LimitSubtext = styled.div`
  font-size: 11px;
  opacity: 0.75;
`;

export const RateText = styled.div`
  font-weight: 800;
`;

export const RateSubtext = styled.div`
  font-size: 11px;
  opacity: 0.75;
`;

export const NextDateText = styled.div`
  font-weight: 700;
`;

export const NextAmountText = styled.div`
  font-size: 12px;
`;

export const DueSubtext = styled.div`
  font-size: 11px;
  opacity: 0.75;
`;

export const CreditorContractText = styled.div`
  font-weight: 700;
`;

export const InstrumentTitleText = styled.div`
  font-size: 12px;
  opacity: 0.75;
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  gap: 6px;
`;
